<p-accordionTab (selectedChange)="togglePanel($event)">
	<ng-template pTemplate="header">
		<div class="grid flex align-items-center w-full pt-2 -mb-2">
			<div [class]="!onExtendedMobile() ? 'col-12' : 'col-12 flex justify-content-center'" class="py-0">
				<span class="font-semibold white-space-nowrap">{{'IMPORT_DATA_INTO_DEVICE' | translate }}</span>
			</div>
		</div>
	</ng-template>
	<div class="grid">
		<div class="col-12">
			<p-table #tableExportListList dataKey="Id" [value]="exportList" [paginator]="true"
				[totalRecords]="totalRecords" [loading]="exportListLoading" [rows]="pageSize" [showCurrentPageReport]="true"
				(onLazyLoad)="loadExportDeviceList($event)" currentPageReportTemplate="{{ 'TABLE_REPORT' | translate }}"
				[autoLayout]="true" [lazy]="true" responsiveLayout="stack">
				<ng-template pTemplate="header">
					<tr>
						<th>
							<div class="flex align-items-center justify-content-center">
								{{ 'NAME' | translate }}
							</div>
						</th>
						<!-- <th>
						<div class="flex align-items-center justify-content-center">
							{{ 'DESCRIPTION' | translate }}
						</div>
					</th> -->
						<th>
							<div class="flex align-items-center justify-content-center">
								{{ 'CREATED_AT' | translate }}
							</div>
						</th>
						<th>
							<div class="flex align-items-center justify-content-center">
								{{ 'UPDATED_AT' | translate }}
							</div>
						</th>
						<th>
						</th>
					</tr>
				</ng-template>
				<ng-template pTemplate="body" let-file>
					<tr>
						<td>
							<span class="p-column-title font-semibold">{{ 'NAME' | translate }}</span>{{file.Name}}
						</td>
						<!-- <td>
						<span class="p-column-title font-semibold">{{ 'DESCRIPTION' | translate }}</span>{{file.Description}}
					</td> -->
						<td>
							<span class="p-column-title font-semibold">{{ 'CREATED_AT' | translate }}</span>{{file.CreatedAt |
							localizedDate: 'medium'}}
						</td>
						<td>
							<span class="p-column-title font-semibold">{{ 'UPDATED_AT' | translate }}</span>{{file.UpdatedAt |
							localizedDate: 'medium'}}
						</td>
						<td>
							<span class="p-column-title font-semibold">
							</span>
							<div class="flex flex-row justify-content-center align-items-center gap-1">
								<p-button [disabled]="taskRunning || offline" label="{{'IMPORT_DATAS' | translate }}"
									tooltipPosition="bottom" icon="pi cm-cloud-arrow-down" size="large"
									(click)="importList(file)" [rounded]="false" [text]="true" severity="primary">
								</p-button>
								<p-button [disabled]="taskRunning"
									pTooltip="{{ 'EDIT_NAME' | translate }} {{ ('LIST' | translate).toLowerCase() }}"
									tooltipPosition="bottom" icon="pi cm-pencil" size="large" (click)="editList(file)"
									[rounded]="false" [text]="true" severity="secondary">
								</p-button>
								<p-button [disabled]="taskRunning" pTooltip="{{ 'DELETE_LIST' | translate }}"
									tooltipPosition="bottom" icon="pi cm-trash" size="large" (click)="deleteList(file)"
									[rounded]="false" [text]="true" severity="danger">
								</p-button>
							</div>
						</td>
					</tr>
				</ng-template>
				<ng-template pTemplate="emptymessage">
					<tr>
						<td colspan="12">{{ 'TABLE_NO_ELEMENT' | translate }}</td>
					</tr>
				</ng-template>
			</p-table>
		</div>
	</div>

</p-accordionTab>
<p-confirmDialog #delListConfDialog class="p-confirm-dialog-content">
	<ng-template pTemplate="footer">
		<div class="col-12 flex justify-content-center">
			<button type="button" pButton [label]="delListConfDialog.acceptButtonLabel" [ngClass]="acceptButtonStyle"
				(click)="delListConfDialog.accept()">
			</button>
			<button type="button" pButton [label]="delListConfDialog.rejectButtonLabel" [ngClass]="rejectButtonStyle"
				(click)="delListConfDialog.reject()">
			</button>
		</div>
	</ng-template>
</p-confirmDialog>